import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import useDidMountEffect from "../../utils/useDidMountEffect";

const CoursesTable = (props) => {
  const { courses, setCourses, selectedCourse, setSelectedCourse } = props;
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const fetchCourses = (search) => {
    let url = "/courses";
    if (search) {
      url += "?search=" + search;
    }

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCourses(data.courses);
      });
  };

  useDidMountEffect(() => {
    fetchCourses(debouncedSearch);
  }, [debouncedSearch]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search, 500]);

  const coursesTable = courses.map((course, index) => (
    <tr
      key={index}
      className={`shadow ${
        selectedCourse && selectedCourse.id == course.id
          ? "bg-primaryYellow500"
          : "hover:bg-gray-50"
      }`}
      onClick={() => {
        setSelectedCourse(course);
      }}
    >
      <td className="p-3">
        <div className="font-medium">{course.title}</div>

        <div className="mt-2 flex gap-2">
          {course.categories.map((category) => (
            <span
              key={category.id}
              className="bg-white text-grey-800 text-xs px-2 py-1 border border-gray-300"
            >
              {category.name}
            </span>
          ))}
        </div>
      </td>
    </tr>
  ));

  return (
    <>
      <div className="w-96 flex flex-col gap-2">
        <div className="relative">
          <input
            type="text"
            placeholder="Wyszukaj..."
            className="pl-10 pr-8 py-1.5 border border-gray-300 text-sm w-full"
            onChange={(e) => setSearch(e.target.value)}
          />
          <svg
            className="w-4 h-4 absolute left-2.5 top-2 text-gray-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
          >
            <path d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z" />
          </svg>
        </div>
        <div className="h-full overflow-auto max-h-[70vh]">
          <table className="w-full text-left border-separate border-spacing-y-4">
            <tbody>{coursesTable}</tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CoursesTable;

CoursesTable.propTypes = {
  selectedCourse: PropTypes.object,
  courses: PropTypes.array,
  setCourses: PropTypes.func,
  setSelectedCourse: PropTypes.func,
};
